  <template>
  <div class="right">
    <div class="mainTop">
      <div class="underHeader">
        <img src="../../assets/img/info.png" alt />
        当前位置：
      </div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
      >
        <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
        <el-breadcrumb-item>上市企业</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 切换 -->
    <div class="rightTab">
      <div class="tab" :class="{active:nowIndex==0}" @click="titleTab(0)">可视化概览</div>
      <div class="tab" :class="{active:nowIndex==1}" @click="titleTab(1)">数据列表</div>
    </div>
    <!-- 可视化 -->
    <Chart3 v-show="nowIndex===0" :initEchart='collapse'></Chart3>
    <!-- 数据列表 -->
    <DataList2 v-show="nowIndex===1"></DataList2>
  </div>
</template>
<script>
import $ from "jquery";
import api from "@/../static/common/api/api.js";
window.api = api;
import magic from "@/../static/common/magic.js";
import axios from "axios";
import Chart3 from "@/components/chart3.vue";
import DataList2 from "@/components/dataList2.vue";

export default {
  props: ['collapse'],
  components: {
    Chart3,
    DataList2
  },
  data() {
    return {
      nowIndex: 0
    };
  },
  computed: {},
  methods: {
    firstShow() {
     let nowIndex1 = JSON.parse(sessionStorage.getItem("nowIndex"))?JSON.parse(sessionStorage.getItem("nowIndex")):0;
      this.nowIndex = nowIndex1;
    },
    // 切换
    titleTab(val) {
      this.nowIndex = val;
    }
  },
  created() {},
  mounted() {
    this.firstShow(); //首次展示
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/moreThanThree.less";
</style>


// WEBPACK FOOTER //
// src/view/enterprises/default.vue